import React, { useEffect, useRef } from 'react';
import { IBoxConstraints } from './interfaces';

interface IProps {
  boxConstraints: IBoxConstraints;
  inverse?: boolean;
}

export function CrossHairs(props: IProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.strokeStyle = props.inverse ? 'rgba(0, 0, 0, 0.31)' : 'rgba(255, 255, 255, 0.31)';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';

    const xStart = Math.floor(props.boxConstraints.maxWidth * 0.5);
    const xEnd = Math.floor(props.boxConstraints.maxHeight);
    ctx.beginPath();
    ctx.moveTo(xStart, 2);
    ctx.lineTo(xStart, xEnd - 2);
    ctx.stroke();
    ctx.closePath();

    const yStart = Math.floor(props.boxConstraints.maxHeight * 0.5);
    const yEnd = Math.floor(props.boxConstraints.maxWidth);
    ctx.beginPath();
    ctx.moveTo(2, yStart);
    ctx.lineTo(yEnd - 2, yStart);
    ctx.stroke();
    ctx.closePath();
  }, [props.boxConstraints, props.inverse]);

  return (
    <canvas
      style={{ position: 'absolute', top: 0, left: 0 }}
      ref={canvasRef}
      width={`${props.boxConstraints.maxWidth}`}
      height={`${props.boxConstraints.maxHeight}`}
    />
  );
}
